import { useTheme } from '../lib/useTheme';
import { useLicenseContext } from '../lib/LicenseContext';
import Link from './Link';

export default function Header() {
  const { theme, toggleTheme } = useTheme();
  const { isPro, startCheckout } = useLicenseContext();
  
  return (
    <header className="header">
      <div className="flex items-center gap-4">
        <img src="/logo_white.svg" alt="PrintQR" style={{ height: 33 }} />
        <h1 className="font-extrabold tracking-tight">PrintQR</h1>
        <nav className="hidden sm:inline">
          <Link to="/" className="text-sm mr-4 hover:underline">Home</Link>
          <Link to="/app" className="text-sm mr-4 hover:underline">App</Link>
          <Link to="/docs/getting-started" className="text-sm mr-4 hover:underline">Docs</Link>
          <Link to="/blog" className="text-sm hover:underline">Blog</Link>
        </nav>
      </div>
      <div className="flex items-center gap-3">
        <button 
          onClick={toggleTheme} 
          className="btn btn-icon" 
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          {theme === 'light' ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="4"></circle>
              <path d="M12 2v2"></path>
              <path d="M12 20v2"></path>
              <path d="m4.93 4.93 1.41 1.41"></path>
              <path d="m17.66 17.66 1.41 1.41"></path>
              <path d="M2 12h2"></path>
              <path d="M20 12h2"></path>
              <path d="m6.34 17.66-1.41 1.41"></path>
              <path d="m19.07 4.93-1.41 1.41"></path>
            </svg>
          )}
        </button>
        {isPro ? (
          <Link to="/app" className="btn btn-primary">
            Open App
          </Link>
        ) : (
          <>
            <button onClick={startCheckout} className="btn btn-primary">
              Unlock Lifetime Pro
            </button>
            <Link to="/app" className="btn btn-outline">
              Try Free
            </Link>
          </>
        )}
      </div>
    </header>
  );
}
